<template>
    <el-container>
        <el-header height="64px">
            <div style="display: flex">
                <div class="product" v-if="product">
                    <el-image :src="product.avatar" lazy style="width: 32px;cursor: pointer;margin: 16px 0;border-radius: 5px"></el-image>
                    <el-popover placement="bottom" trigger="click" width="350px" ref="popover">
                        <template #default>
                            <el-scrollbar max-height="300px">
                                <div v-for="p in getProductList()" :key="p.key" @click="switchProduct(p)">
                                    <div class="product-nav"
                                         :style="{backgroundColor: p.key===product.key?'var(--el-border-color-lighter)': ''}">
                                        <img :src="p.avatar" style="width: 40px;border-radius: 5px">
                                        <div style="margin-left: 15px;white-space: nowrap;width: 280px">
                                            <el-row style="line-height: 40px;font-size: 16px;">
                                                {{ p.name }}
                                            </el-row>
                                        </div>
                                    </div>
                                </div>
                            </el-scrollbar>
                        </template>
                        <template #reference>
                            <span style="margin-left: 10px;cursor: pointer;padding: 0 10px;line-height: 64px;font-size: 20px;color: var(--el-text-color-regular);">
                                {{ product.name }}
                                <el-icon size="14px">
                                    <CaretBottom/>
                                </el-icon>
                            </span>
                        </template>
                    </el-popover>
                </div>
            </div>
            <div>
                <el-switch style="margin: 16px" v-model="dark" @change="changeDark" class="dark-switch"
                           active-color="#44444" :active-icon="Moon" :inactive-icon="Sunny" inline-prompt></el-switch>
                <el-button size="small" type="text" @click="logout()">退出登录</el-button>
            </div>
        </el-header>
        <el-container style="background-color: var(--el-border-color-extra-light)" :style="{height: height + 'px'}">
            <aside-nav ref="nav">
                <aside-group v-if="is_manager()" title="管理面板">
                    <aside-item v-if="is_manager()" icon="User" title="兼职用户" index="PartTime"></aside-item>
                </aside-group>
                <aside-group title="素材库">
                    <aside-item icon="Files" title="全局图库" index="Index"></aside-item>
                    <aside-item v-if="has_mi_index()" icon="Files" title="小米图库" index="MiIndex"></aside-item>
                    <aside-item icon="CollectionTag" title="素材标签" index="Tag"></aside-item>
                    <aside-item icon="Star" title="素材评分" index="Score"></aside-item>
                    <aside-item icon="Star" title="每日表现" index="Metric"></aside-item>
                </aside-group>
                <aside-group title="图库页">
                    <aside-item icon="Reading" title="分类管理" index="Category"></aside-item>
                    <aside-item icon="Aim" title="新手引导图" index="Rookie"></aside-item>
                    <aside-item icon="Timer" title="每日上新" index="Update"></aside-item>
                    <aside-item icon="Star" title="封面图" index="Cover"></aside-item>
                </aside-group>
                <aside-group title="发现页">
                  <aside-item icon="CollectionTag" title="合集" index="Collection"></aside-item>
                </aside-group>
                <aside-group title="Daily页">
                    <aside-item icon="Calendar" title="日历" index="Daily"></aside-item>
                    <aside-item icon="Calendar" title="挑战" index="DailyChallenge"></aside-item>
                </aside-group>
                <aside-group title="我的">
                    <aside-item icon="GoldMedal" title="成就" index="Achievement"></aside-item>
                </aside-group>
                <aside-group title="运营活动">
                  <aside-item icon="Monitor" title="弹窗" index="Popup"></aside-item>
                  <aside-item icon="Picture" title="轮播" index="Carousel"></aside-item>
                </aside-group>
                <aside-group title="内购">
                  <aside-item index="Subscription" title="订阅活动" icon="Goods"></aside-item>
                  <aside-item index="NewbieSales" title="新用户活动" icon="Goods"></aside-item>
                </aside-group>
            </aside-nav>
            <el-main :style="{padding: $route.name === 'Tag'?'0':'var(--el-main-padding)'}">
                <router-view></router-view>
            </el-main>
        </el-container>
    </el-container>
</template>
<script>
import {useDark, useToggle} from '@vueuse/core';
import AsideNav from "./base/AsideNav.vue";
import AsideGroup from "./base/AsideGroup.vue";
import AsideItem from "./base/AsideItem.vue";
import axios from "ts-axios-new";
import {Sunny, Moon} from '@element-plus/icons-vue'
import {has_mi_index, is_manager} from "./libs/permission";
import {changeProduct, getProduct, getProductList} from "./libs/app";

export default {
    name: 'App',
    components: {AsideGroup, AsideItem, AsideNav},
    data() {
        return {
            dark: window.matchMedia('(prefers-color-scheme: dark)').matches, Sunny, Moon,
            width: document.documentElement.clientWidth,
            height: document.documentElement.clientHeight - 64,
            media: window.matchMedia('(prefers-color-scheme: dark)'),
            country_list: [], cdn_url: import.meta.env.VITE_CDN_URL,
            user: {
                user_id: '',
                avatar: '',
                name: '',
                email: '',
                access: [],
            },
            part_time_mode: false,
            product: null,
        }
    },
    methods: {
      has_mi_index,
        is_manager,
        getProductList,
        changeDark() {
            useToggle(useDark())(this.dark);
        },
        handleScroll() {
            this.height = document.documentElement.clientHeight - 64;
            this.width = document.documentElement.clientWidth;
        },
        logout() {
          axios.get(`/cms/v1/logout`).then(_ => {
            location.reload();
          })
        },
        switchProduct(p) {
            this.product = p
            changeProduct(p)
            this.$refs.popover.hide()
            location.reload();
        },
    },
    mounted() {
        window.onresize = _ => {
            this.handleScroll();
        };
        this.media.addEventListener('change', e => {
            this.dark = e.matches;
            this.changeDark();
        });
        this.changeDark();
        axios.get('https://console.plutodesk.com/api/v1/country').then(res => {
            this.country_list = res.data.data.countryList;
        });
        this.product = getProduct()
    },
}
</script>
<style>
html, body {
    margin: 0;
    padding: 0;
}

.el-header {
    display: flex;
    padding: 0 20px;
    justify-content: space-between;
    border-bottom: solid 1px var(--el-border-color-light);
    background-color: var(--el-bg-color);
}

.dark-switch i {
    color: var(--el-text-color-primary) !important;
}

.product {
    font-size: 20px;
    line-height: 64px;
    display: flex;
}

.product-nav {
    padding: 7px 5px;
    position: relative;
    cursor: pointer;
    display: flex;
}

.product-nav:hover {
    background-color: var(--el-border-color-extra-light);
    color: var(--el-text-color-secondary);
}
</style>